import layoutHeaderAside from "@/layout/header-aside";

// 由于懒加载页面太多的话会造成webpack热更新太慢，所以开发环境不使用懒加载，只有生产环境使用懒加载
const _import = require("@/libs/util.import." + process.env.NODE_ENV);

/**
 * 在主框架内显示
 */
const frameIn = [
  {
    path: "/",
    redirect: {
      name: "index"
    },
    component: layoutHeaderAside,
    children: [
      // 首页
      {
        path: "index",
        name: "index",
        meta: {
          auth: true
        },
        component: _import("system/index")
      },
      // 系统 前端日志
      {
        path: "log",
        name: "log",
        meta: {
          title: "前端日志",
          auth: true
        },
        component: _import("system/log")
      },
      // 刷新页面 必须保留
      {
        path: "refresh",
        name: "refresh",
        hidden: true,
        component: _import("system/function/refresh")
      },
      // 页面重定向 必须保留
      {
        path: "redirect/:route*",
        name: "redirect",
        hidden: true,
        component: _import("system/function/redirect")
      },
      // 下面都是我的页面：
      {
        path: "UserInfo",
        name: "UserInfo",
        meta: {
          title: "用户及权限",
          auth: true,
          cache: true //启动缓存
        },
        component: _import("pages/UserInfo/UserInfo")
      },

      {
        path: "getMaterials",
        name: "getMaterials",
        meta: {
          title: "领料单",
          auth: true,
          cache: true
        },
        component: _import("pages/materials/getMaterials")
      },
      {
        path: "packingPatrol",
        name: "packingPatrol",
        meta: {
          title: "包装巡检",
          auth: true,
          cache: true
        },
        component: _import("pages/packingPatrol/packingPatrol")
      },

      {
        path: "dailyPatrol",
        name: "dailyPatrol",
        meta: {
          title: "日常巡检",
          auth: true,
          cache: true
        },
        component: _import("pages/dailyPatrol/dailyPatrol")
      },
      {
        path: "dailyPatrolTemplate",
        name: "dailyPatrolTemplate",
        meta: {
          title: "日常巡检模板",
          auth: true,
          cache: true
        },
        component: _import(
          "pages/dailyPatrol/dailyPatrolTemplate/dailyPatrolTemplate"
        )
      },
      {
        path: "assemblyFaclility",
        name: "assemblyFaclility",
        meta: {
          title: "流水线设备点检",
          auth: true,
          cache: true
        },
        component: _import("pages/assemblyFaclility/assemblyFaclility")
      },
      {
        path: "orderMaterialsList",
        name: "orderMaterialsList",
        meta: {
          title: "配件包装",
          auth: true,
          cache: true
        },
        component: _import("pages/orderMaterials/orderMaterialsList")
      },
      {
        path: "productionOrder",
        name: "productionOrder",
        meta: {
          title: "指令单包装计划",
          auth: true,
          cache: true
        },
        component: _import("pages/productionOrder/productionOrder")
      },
      {
        path: "orderSync",
        name: "orderSync",
        meta: {
          title: "同步指令单",
          auth: true,
          cache: true
        },
        component: _import("pages/productionOrder/orderSync")
      },
      {
        path: "sellOrderSync",
        name: "sellOrderSync",
        meta: {
          title: "生产指令单",
          auth: true,
          cache: true
        },
        component: _import("pages/sellSheet/sellOrderSync")
      },
      {
        path: "YproductionOrder",
        name: "YproductionOrder",
        meta: {
          title: "生产指令单",
          auth: true,
          cache: true
        },
        component: _import("pages/Y_SCOrder/YproductionOrder")
      },
      {
        path: "shipmentPlan",
        name: "shipmentPlan",
        meta: {
          title: "指令单拆分",
          auth: true,
          cache: true
        },
        component: _import("pages/sellSheet/shipmentPlan")
      },
      {
        path: "remarksTemplate",
        name: "remarksTemplate",
        meta: {
          title: "备注模板",
          auth: true,
          cache: true
        },
        component: _import("pages/sellSheet/remarksTemplate/remarksTemplate")
      },
      {
        path: "customerRemarks",
        name: "customerRemarks",
        meta: {
          title: "产品包装相关",
          auth: true,
          cache: true
        },
        component: _import("pages/sellSheet/customerRemarks/customerRemarks")
      },
      {
        path: "sellSheetAssist",
        name: "sellSheetAssist",
        meta: {
          title: "帮助文档",
          auth: true,
          cache: true
        },
        component: _import("pages/sellSheet/sellSheetAssist")
      },

      {
        path: "productionPlanList",
        name: "productionPlanList",
        meta: {
          title: "包装计划查询",
          auth: true,
          cache: true
        },
        component: _import("pages/productionPlanList/productionPlanList")
      },

      {
        path: "productionPlanListDisable",
        name: "productionPlanListDisable",
        meta: {
          title: "包装计划查询",
          auth: true,
          cache: true
        },
        component: _import("pages/productionPlanListDisable/productionPlanList")
      },
      {
        path: "onWaterRecord",
        name: "onWaterRecord",
        meta: {
          title: "入库记录",
          auth: true,
          cache: true
        },
        component: _import("pages/waterRecord/onWaterRecord/onWaterRecord")
      },
      {
        path: "outWaterRecord",
        name: "outWaterRecord",
        meta: {
          title: "出库记录",
          auth: true,
          cache: true
        },
        component: _import("pages/waterRecord/outWaterRecord/outWaterRecord")
      },

      {
        path: "inventoryRecords",
        name: "inventoryRecords",
        meta: {
          title: "库存记录",
          auth: true,
          cache: true
        },
        component: _import(
          "pages/waterRecord/inventoryRecords/inventoryRecords"
        )
      },
      {
        path: "entrepotWater",
        name: "entrepotWater",
        meta: {
          title: "库存流水",
          auth: true,
          cache: true
        },
        component: _import("pages/waterRecord/entrepotWater/entrepotWater")
      },
      //入库记录
      {
        path: "productionTeam",
        name: "productionTeam",
        meta: {
          title: "包装小组管理",
          auth: true,
          cache: true
        },
        component: _import("pages/productionTeam/productionTeam")
      },
      //班前会//启动缓存
      {
        path: "Meeting",
        name: "Meeting",
        meta: {
          title: "班前会列表",
          auth: true,
          cache: true
        },
        component: _import("pages/Meeting/Meeting")
      },
      {
        path: "statistics",
        name: "statistics",
        meta: {
          title: "统计",
          auth: true,
          cache: true
        },
        component: _import("pages/statistics/statistics")
      },
      {
        path: "UpdateLogInfo",
        name: "UpdateLogInfo",
        meta: {
          title: "更新日志",
          auth: true,
          cache: true //启动缓存
        },
        component: _import("pages/UpdateLogInfo/UpdateLogInfo")
      },
      {
        path: "MenuInfo",
        name: "MenuInfo",
        meta: {
          title: "系统菜单设置",
          auth: true,
          cache: true //启动缓存
        },
        component: _import("pages/MenuInfo/MenuInfo")
      },

      {
        path: "NoticeInfo",
        name: "NoticeInfo",
        meta: {
          title: "公告管理",
          auth: true,
          cache: true //启动缓存
        },
        component: _import("pages/NoticeInfo/NoticeInfo")
      },
      {
        path: "ItemInfo",
        name: "ItemInfo",
        meta: {
          title: "商品档案",
          auth: true,
          cache: true //启动缓存
        },
        component: _import("pages/Basic/ItemInfo/ItemInfo")
      },
      {
        path: "StoreInInfo",
        name: "StoreInInfo",
        meta: {
          title: "入库单",
          auth: true,
          cache: true //启动缓存
        },
        component: _import("pages/Store/StoreInInfo/StoreInInfo")
      },
      {
        path: "StoreOutInfo",
        name: "StoreOutInfo",
        meta: {
          title: "出库单",
          auth: true,
          cache: true //启动缓存
        },
        component: _import("pages/Store/StoreOutInfo/StoreOutInfo")
      },
      {
        path: "StoreReport",
        name: "StoreReport",
        meta: {
          title: "库存统计",
          auth: true,
          cache: true //启动缓存
        },
        component: _import("pages/Store/StoreReport/StoreReport")
      },
      {
        path: "productDatum",
        name: "productDatum",
        meta: {
          title: "产品资料",
          auth: true,
          cache: true
        },
        component: _import("pages/productDatum/productDatum")
      },

      {
        path: "qualityPatrol",
        name: "qualityPatrol",
        meta: {
          title: "质检管理",
          auth: true,
          cache: true
        },
        component: _import("pages/qualityTesting/qualityPatrol")
      },
      {
        path: "assemblyOrder",
        name: "assemblyOrder",
        meta: {
          title: "质检管理",
          auth: true,
          cache: true
        },
        component: _import("pages/assemblyUnit/assemblyOrder")
      },
      {
        path: "semiWarehouseSet",
        name: "semiWarehouseSet",
        meta: {
          title: "半成品出料区域管理",
          auth: true,
          cache: true
        },
        component: _import("pages/semiWarehouseSet/semiWarehouseSet")
      },
      {
        path: "semiPureArea",
        name: "semiPureArea",
        meta: {
          title: "半成品收料区域管理",
          auth: true,
          cache: true
        },
        component: _import("pages/semiPureArea/semiPureArea")
      },
      {
        path: "dataBoard",
        name: "dataBoard",
        meta: {
          title: "数据看板",
          auth: true,
          cache: true
        },
        component: _import("pages/dataBoard/dataBoard")
      }
    ]
  }
];

/**
 * 在主框架之外显示
 */
const frameOut = [
  // 登录
  {
    path: "/login",
    name: "login",
    component: _import("system/login")
  }
];

/**
 * 错误页面
 */
const errorPage = [
  {
    path: "*",
    name: "404",
    component: _import("system/error/404")
  }
];

// 导出需要显示菜单的
export const frameInRoutes = frameIn;

// 重新组织后导出
export default [...frameIn, ...frameOut, ...errorPage];
